import styled from "styled-components/macro";
import {useHistory, useParams} from "react-router-dom";

import {useCallback, useEffect} from "react";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Wrapper from "../../components/wrapper";
import PostList from "../../components/post_list";
import HeaderData from "../../components/header_data";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import {useModal} from "../../store";
import CreatePost from "../../components/create_post";
import SaveFolders from "../../components/save_folders";
import WikiIndex from "../../components/wiki_index";
import CreateMessage from "../../components/create_message";
import CreateCommunity from "../../components/create_community";
import {isPseudoCommunity} from "../../store/communites";
import ResetPassword from "../../components/modals/reset_password";
import ChangePassword from "../../components/modals/change_password";
import LegacySortBar from "../../components/legacy/legacy_sort_bar";
import useWindowDimensions from "../../utils/dimensions";
import ProSubscribe from "../../components/pro_subscribe";
import Onboarding from "../../components/onboarding";
import CommunityOnboarding from "../../components/community_onboarding";

const ManageMenu = styled(({className, type}) => {

    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const style = useCommunityStyle(community);

    const modal = useModal();
    const history = useHistory();
    const goHomeIfDismissed = useCallback((dismissed) => {
        if (dismissed) {
            history.replace('/');
        }
    }, [history]);
    useEffect(() => {
        if (type === 'create_post') {
            modal.open(CreatePost, {community}).then(goHomeIfDismissed);
        } else if (type === 'create_message') {
            modal.open(CreateMessage).then(goHomeIfDismissed);
        } else if (type === 'saved') {
            modal.open(SaveFolders).then(goHomeIfDismissed);
        } else if (type === 'wiki_index') {
            modal.open(WikiIndex, {community}).then(goHomeIfDismissed);
        } else if (type === 'create_community') {
            modal.open(CreateCommunity).then(goHomeIfDismissed);
        } else if (type === 'reset_password') {
            modal.open(ResetPassword).then(goHomeIfDismissed);
        } else if (type === 'change_password') {
            modal.open(ChangePassword).then(goHomeIfDismissed);
        } else if (type === 'pro') {
            modal.open(ProSubscribe).then(goHomeIfDismissed);
        } else if (type === 'onboarding') {
            modal.open(Onboarding).then(goHomeIfDismissed);
        } else if (type === 'community_onboarding') {
            modal.open(CommunityOnboarding).then(goHomeIfDismissed);
        }
    }, []);

    const {width} = useWindowDimensions();

    return (
        <div className={className}>
            <HeaderData title={community === "TheDonald" ? "The Donald" : "Scored"} showBrand={false} community={community} community_style={style}/>
            <Header>
                {(community !== "TheDonald" || width <= 780) && <TopBar legacyConversion={community === "TheDonald"} />}
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                    </>
                }
                {community === "TheDonald" && width > 780 && <LegacySortBar />}
            </Header>
            <SortBar community={community} />
            <Container>
                <Wrapper>
                    <Main>
                        <PostList loading />
                    </Main>
                </Wrapper>
                <Sidebar sidebar={style?.sidebar} topics={community === 'win' || community === 'all'} />
            </Container>
            <Footer/>
        </div>
    );
})``;

export default ManageMenu;
